(function () {
  function initFadeSlideshows(scope) {
    const root = scope || document;

    root.querySelectorAll(".slideshow").forEach((ss) => {
      const slides = ss.querySelectorAll(".slideshow__slide");
      if (slides.length <= 1) return;

      if (ss.dataset.fadeInit === "1") return;
      ss.dataset.fadeInit = "1";

      let i = 0;
      slides.forEach((s, idx) => s.classList.toggle("is-active", idx === 0));

      setInterval(() => {
        slides[i].classList.remove("is-active");
        i = (i + 1) % slides.length;
        slides[i].classList.add("is-active");
      }, 6000);
    });
  }

  document.addEventListener("DOMContentLoaded", () => initFadeSlideshows(document));
  document.addEventListener("shopify:section:load", (e) => initFadeSlideshows(e.target));
})();